<template>
  <div>
    <template v-if="!full">
      <a-table :data-source="list" bordered :pagination="false">
        <a-table-column title="帐户名">
          <template slot-scope="text">
            <a-input v-if="text.editable" v-model="editingBank.accName" />
            <span v-else>{{ text.accName }}</span>
          </template>
        </a-table-column>
        <a-table-column title="银行账号">
          <template slot-scope="text">
            <a-input v-if="text.editable" v-model="editingBank.bankAccNum" />
            <span v-else>{{ text.bankAccNum }}</span>
          </template>
        </a-table-column>
        <a-table-column v-if="!readonly" title="操作" align="center">
          <template slot-scope="text, row, index">
            <a-space v-if="text.editable">
              <span style="color: #1890ff; cursor: pointer" @click="save(index)">保存</span>
              <span style="color: #f00; cursor: pointer" @click="cancel(text, index)">取消</span>
            </a-space>
            <a-space v-else>
              <span style="color: #1890ff; cursor: pointer" @click="edit(text, index)">编辑</span>
              <span style="color: #f00; cursor: pointer" @click="remove(index)">删除</span>
            </a-space>
          </template>
        </a-table-column>
      </a-table>
    </template>

    <template v-else>
      <div v-for="(item, index) in list" :key="index" class="bank-card">
        <a-row :gutter="16">
          <a-col :span="8">
            <a-form-item label="帐户名">
              <a-input v-if="item.editable" v-model="editingBank.accName" />
              <span v-else>{{ item.accName }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="银行账号">
              <a-input v-if="item.editable" v-model="editingBank.bankAccNum" />
              <span v-else>{{ item.bankAccNum }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="账户性质">
              <a-select v-if="item.editable" v-model="editingBank.accNatureName" style="width:100%">
                <a-select-option value="1">公司账户</a-select-option>
                <a-select-option value="2">个人账户</a-select-option>
              </a-select>
              <span v-else>{{ item.accNatureName === '1' ? '公司账户' : item.accNatureName === '2' ? '个人账户' : item.accNatureName }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-item label="开户大行代码">
              <a-input v-if="item.editable" v-model="editingBank.openBankCode" />
              <span v-else>{{ item.openBankCode }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="开户大行">
              <a-input v-if="item.editable" v-model="editingBank.openBankName" />
              <span v-else>{{ item.openBankName }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="开户行编码">
              <a-input v-if="item.editable" v-model="editingBank.openBranchCode" />
              <span v-else>{{ item.openBranchCode }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="开户行">
              <a-input v-if="item.editable" v-model="editingBank.openBranch" />
              <span v-else>{{ item.openBranch }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-item label="币种代码">
              <a-input v-if="item.editable" v-model="editingBank.curCode" />
              <span v-else>{{ item.curCode }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="币种">
              <a-input v-if="item.editable" v-model="editingBank.curName" />
              <span v-else>{{ item.curName }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="账户状态">
              <a-select v-if="item.editable" v-model="editingBank.bankStatus" style="width:100%">
                <a-select-option value="0">启用</a-select-option>
                <a-select-option value="1">停用</a-select-option>
              </a-select>
              <span v-else>{{ item.bankStatus === '0' ? '启用' : item.bankStatus === '1' ? '停用' : item.bankStatus }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="是否开票账户">
              <a-select v-if="item.editable" v-model="editingBank.isNtInvAcc" style="width:100%">
                <a-select-option value="0">否</a-select-option>
                <a-select-option value="1">是</a-select-option>
              </a-select>
              <span v-else>{{ item.isNtInvAcc === '1' ? '是' : item.isNtInvAcc === '0' ? '否' : item.isNtInvAcc }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="8">
            <a-form-item label="联行号">
              <a-input v-if="item.editable" v-model="editingBank.bankRoute" />
              <span v-else>{{ item.bankRoute }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="IBAN">
              <a-input v-if="item.editable" v-model="editingBank.iban" />
              <span v-else>{{ item.iban }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="SWIFT Code">
              <a-input v-if="item.editable" v-model="editingBank.swiftCode" />
              <span v-else>{{ item.swiftCode }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="8">
            <a-form-item label="账户标识">
              <a-input v-if="item.editable" v-model="editingBank.bankId" />
              <span v-else>{{ item.bankId }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <div v-if="!readonly">
          <div v-if="item.editable" class="bank-card-actions">
            <a-space>
              <a-button type="primary" size="small" @click="save(index)">保存</a-button>
              <a-button size="small" @click="cancel(item, index)">取消</a-button>
            </a-space>
          </div>
          <div v-else class="bank-card-actions">
            <a-space>
              <a-button type="link" @click="edit(item, index)">编辑</a-button>
              <a-button type="link" danger @click="remove(index)">删除</a-button>
            </a-space>
          </div>
        </div>
      </div>
    </template>

    <a-button v-if="!readonly" type="primary" style="margin-top: 12px" @click="add">新增银行信息</a-button>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    full: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      editingBank: {},
    };
  },

  methods: {
    add() {
      this.$emit("addBank");
    },
    remove(index) {
      this.$emit("removeBank", index);
    },
    edit(text, index) {
      this.editingBank = { ...text };
      this.$emit("setBank", {
        index,
        element: {
          ...text,
          editable: true,
        },
      });
    },
    cancel(text, index) {
      this.editingBank = {};
      this.$emit("setBank", {
        index,
        element: {
          ...text,
          editable: undefined,
        },
      });
    },
    save(index) {
      this.$emit("setBank", {
        index,
        element: {
          ...this.editingBank,
          editable: undefined,
        },
      });
      this.editingBank = {};
    },
  },
};
</script>

<style scoped>
.bank-card {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 12px;
}
.bank-card-actions {
  text-align: right;
  margin-top: 8px;
}
</style>
